












































import { Component, Vue } from 'vue-property-decorator';
import storage from '../../utils/storage';
import Loading from '../../components/Loading.vue';
import moment from 'moment';
@Component({
  components: {
    Loading,
  },
})
export default class AsinProfit extends Vue {
  private user: any;
  private asinData = [];
  private pmColumns = [];
  private asinColumns =  [];
  private headers: any = {
    authorization: 'authorization-text',
  };
  private moment: any = moment;
  private dataMonthTime: any = moment(new Date()).format('YYYY-MM');
  private daysInMonth: number = this.moment(new Date()).format('DD');
  // private dataTime: any = moment(new Date()).add(-2, 'days').format('YYYY-MM-DD');
  private spinning = false;
  private dataJson: any = [];
  private pmAsinDayInfo: any = [];
  private monthInfo: any = [];
  private mounted() {
    this.user = storage.get('user');
    if (this.user) {
      console.log('is login');
      // this.getData();
    } else {
     this.$router.push({
        path: '/login',
      });
    }

  }

  private async getData() {
    this.clearJson();
    const that = this;
    this.spinning = true;
    // 清空数组
    const url: string = '/api/getProfit';
    const dataMonthTime = this.dataMonthTime;
    const daysInMonth = this.daysInMonth - 1;
    const args = {
      dataMonthTime,
      daysInMonth,
      team: this.user.team,
    };
    this.pushColumns(dataMonthTime, daysInMonth);
    this.axios.post(url, args).then((res) => {
      const dataJson = res.data.data;
      const pmAsinDayInfo = 'pmAsinDayInfo';
      const monthInfo = 'monthInfo';
      that.pmAsinDayInfo = dataJson[pmAsinDayInfo];
      that.monthInfo = dataJson[monthInfo];
      this.spinning = false;
    }).catch((err) => {
      this.spinning = false;
    });
  }
  private pushColumns(dataMonthTime: string, daysInMonth: number) {
    this.pmColumns.splice(0, this.pmColumns.length);
    this.asinColumns.splice(0, this.asinColumns.length);
    // @ts-ignore：无法被执行的代码的错误
    this.pmColumns = [
      // @ts-ignore：无法被执行的代码的错误
      { title: 'PM', width: '60px', dataIndex: 'people', key: 'people', fixed: 'left' },
      // @ts-ignore：无法被执行的代码的错误
      { title: '月销量', width: '110px', dataIndex: 'orders', key: 'orders', fixed: 'left' },
      // @ts-ignore：无法被执行的代码的错误
      { title: '月毛利率', width: '120px', dataIndex: 'profit', key: 'profit', fixed: 'left' },
      // @ts-ignore：无法被执行的代码的错误
      { title: '月cpc', width: '120px', dataIndex: 'cpc', key: 'cpc', fixed: 'left' },
    ];
    // @ts-ignore：无法被执行的代码的错误
    this.asinColumns = [
      // @ts-ignore：无法被执行的代码的错误
      { title: 'PM', width: '60px', dataIndex: 'people', key: 'people', fixed: 'left' },
      // @ts-ignore：无法被执行的代码的错误
      { title: '分类', width: '90px', dataIndex: 'type', key: 'type', fixed: 'left' },
      // @ts-ignore：无法被执行的代码的错误
      { title: 'ASIN', width: '128px', dataIndex: 'asin', key: 'asin', fixed: 'left' },
      // @ts-ignore：无法被执行的代码的错误
      { title: '品牌', width: '86px', dataIndex: 'brand', key: 'brand', fixed: 'left' },
      // @ts-ignore：无法被执行的代码的错误
      { title: '产品名称', width: '139px', dataIndex: 'title_CN', key: 'title_CN', fixed: 'left' },
    ];
    for (let k = daysInMonth; k > 0; k--) {
      const day = dataMonthTime + '-' + (k < 10 ? ('0' + k) : k);
      const data: string =  `${day}_date`;
      const orders: string =  `${day}_orders`;
      const profit: string =  `${day}_profit`;
      const cpc: string =  `${day}_cpc`;
      const cpcConversion =  `${day}_cpc_conversion`;
      // @ts-ignore：无法被执行的代码的错误
      this.pmColumns.push({title: '日期', dataIndex: data, key: data, width: '110px'});
      // @ts-ignore：无法被执行的代码的错误
      this.pmColumns.push({title: '销量', dataIndex: orders, key: orders, width: '80px' });
      // @ts-ignore：无法被执行的代码的错误
      this.pmColumns.push({title: '毛利润', dataIndex: profit, key: profit, width: '100px' });
      // @ts-ignore：无法被执行的代码的错误
      this.pmColumns.push({title: 'CPC花费', dataIndex: cpc, key: cpc, width: '100px' });
      // @ts-ignore：无法被执行的代码的错误
      this.asinColumns.push({title: '日期', dataIndex: data, key: data, width: '110px' });
      // @ts-ignore：无法被执行的代码的错误
      this.asinColumns.push({title: '销量', dataIndex: orders, key: orders, width: '80px' });
      // @ts-ignore：无法被执行的代码的错误
      this.asinColumns.push({title: '毛利润', dataIndex: profit, key: profit, width: '100px' });
      // @ts-ignore：无法被执行的代码的错误
      this.asinColumns.push({title: 'CPC花费', dataIndex: cpc, key: cpc, width: '100px' });
      // @ts-ignore：无法被执行的代码的错误
      this.asinColumns.push({title: '转化率', dataIndex: cpcConversion, key: cpcConversion, width: '90px' });
    }

  }
  private clearJson() {
    this.pmAsinDayInfo.splice(0, this.pmAsinDayInfo.length);
  }
  private SKUChange(info: any) {
    if (info.file.status !== 'uploading') {
      // console.log(info.file, info.fileList);
    }
    if (info.file.status === 'done') {
      this.$message.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      this.$message.error(`${info.file.name} file upload failed.`);
    }
  }

  private onPickerChange(date: any, dateString: string) {
    this.dataMonthTime = dateString;
    if ( this.moment(new Date()).format('YYYY-MM') !== this.moment(this.dataMonthTime).format('YYYY-MM') ) {
      this.daysInMonth = this.moment(this.dataMonthTime, 'YYYY-MM').daysInMonth();
    } else {
      this.daysInMonth = this.moment(this.dataMonthTime).format('DD');
    }
  }
}
